export default "__VITE_ASSET__XVznT_wd__"